'use client';

import {useTranslation} from 'react-i18next';
import {Button} from '../primitives';

export interface RegisterInterestButtonProps {
  onClick: () => void;
}

export function RegisterInterestButton({onClick}: RegisterInterestButtonProps) {
  const {t} = useTranslation();
  return (
    <Button variant="contained-dark" onClick={onClick}>
      {t('register_interest')}
    </Button>
  );
}

RegisterInterestButton.displayName = 'RegisterInterestButton';

export interface TakeTourButtonProps {
  href: string;
  onClick?: () => void;
}

export function TakeTourButton({href, onClick}: TakeTourButtonProps) {
  const {t} = useTranslation();
  return (
    <Button variant="outlined-dark" component="a" href={href} target="_blank" rel="noopener noreferrer" onClick={onClick}>
      {t('take_a_tour')}
    </Button>
  );
}

TakeTourButton.displayName = 'TakeTourButton';
